import PageContent from "~/components/design-system/pages/internal/PageContent"
import PageToolbar from "~/components/design-system/pages/internal/PageToolbar"
import {
  useRegisterInspector,
  useRegisterViewConfiguration,
} from "~/components/design-system/pages/internal/InspectorContext"
import { type AnalysisPageProps } from "~/components/design-system/pages/types"
import { Tabs } from "~/components/reusable/Tabs"

/**
 * Archetype page — the page IS the analytics (charts, filtered deep-dives).
 * Defaults: p-4, sticky filter toolbar, inspector closed by default.
 * Canonical intent: {@link ../intents.ts ANALYSIS_PAGE_INTENT}.
 * Approved surface: design-system/APPROVED.md · Patterns: design-system/pages/README.md.
 */
const AnalysisPage = ({
  children,
  toolbar,
  viewTabs,
  inspector,
  inspectorDefaultOpen = true,
  inspectorWidth = "md",
  inspectorClassName,
  contentClassName,
  viewConfiguration,
  fillContent = false,
}: AnalysisPageProps) => {
  useRegisterInspector(inspector, inspectorDefaultOpen, inspectorWidth, inspectorClassName)
  useRegisterViewConfiguration(viewConfiguration)
  return (
    <>
      {toolbar && <PageToolbar>{toolbar}</PageToolbar>}
      <PageContent archetype="analysis" className={contentClassName} fill={fillContent}>
        {children}
        {viewTabs && <Tabs tabs={viewTabs.items} onValueChange={viewTabs.onChange} />}
      </PageContent>
    </>
  )
}

export default AnalysisPage
